import React from "react";
import { Redirect } from 'react-router-dom';

const AuthRedirect = () => {
    return <Redirect to="/403"/>
};
export default AuthRedirect;